// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/AletteMaersk-01.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` 
.login-wrapper{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) lightgray 0% / cover no-repeat;
    background-size: cover;  /* This makes the image cover the whole background */
    background-position: center;  /* This centers the image */
    background-repeat: no-repeat;
    min-height: 100vh;
   }
 
.cardlogin {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px; /* Adjust the width as needed */
    height: 200px; /* Adjust the height as needed */
    background: #fffdfd;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 85%;
    right: -5%;
    transform: translate(-50%, -50%);
    flex-direction: column;
  }

  
  .cardlogin .hdr{
  display: flex;
  font-size: x-large;
  text-align: center;
  font-weight: 900;
  font-family: 'Maersk Headline';
  margin-bottom: 5%;
  }

  .homepage {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 100vw;
    overflow: hidden;
    
  }

  .ava_col	{color: #4CAF50}
  .inp_col    {color: #2196F3}
  .rej_col    {color: #F44336}
  .acc_col    {color: #388E3C}
  .mat_col    {color: #FF9800}
  .matn_col   {color: #9E9E9E}
  .ntp_col    {color: #9E9E9E}   `, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":";AACA;IACI,kFAA+E;IAC/E,sBAAsB,GAAG,oDAAoD;IAC7E,2BAA2B,GAAG,2BAA2B;IACzD,4BAA4B;IAC5B,iBAAiB;GAClB;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAE,+BAA+B;IAC7C,aAAa,EAAE,gCAAgC;IAC/C,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gCAAgC;IAChC,sBAAsB;EACxB;;;EAGA;EACA,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;;EAElB;;EAEA,UAAU,cAAc;EACxB,aAAa,cAAc;EAC3B,aAAa,cAAc;EAC3B,aAAa,cAAc;EAC3B,aAAa,cAAc;EAC3B,aAAa,cAAc;EAC3B,aAAa,cAAc","sourcesContent":[" \n.login-wrapper{\n    background: url('../Images/AletteMaersk-01.jpg') lightgray 0% / cover no-repeat;\n    background-size: cover;  /* This makes the image cover the whole background */\n    background-position: center;  /* This centers the image */\n    background-repeat: no-repeat;\n    min-height: 100vh;\n   }\n \n.cardlogin {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 350px; /* Adjust the width as needed */\n    height: 200px; /* Adjust the height as needed */\n    background: #fffdfd;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    position: absolute;\n    top: 85%;\n    right: -5%;\n    transform: translate(-50%, -50%);\n    flex-direction: column;\n  }\n\n  \n  .cardlogin .hdr{\n  display: flex;\n  font-size: x-large;\n  text-align: center;\n  font-weight: 900;\n  font-family: 'Maersk Headline';\n  margin-bottom: 5%;\n  }\n\n  .homepage {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    min-width: 100vw;\n    overflow: hidden;\n    \n  }\n\n  .ava_col\t{color: #4CAF50}\n  .inp_col    {color: #2196F3}\n  .rej_col    {color: #F44336}\n  .acc_col    {color: #388E3C}\n  .mat_col    {color: #FF9800}\n  .matn_col   {color: #9E9E9E}\n  .ntp_col    {color: #9E9E9E}   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
